<template>
    <div>
        <Hero :title="$t('case_studies.title')" :lead="$t('case_studies.lead')" class="bg-white" />

        <div class="case-studies-wrapper relative pt-4 sm:pt-10 lg:pt-10 pb-12 md:pb-16 lg:pb-20 bg-white text-black">
            <div class="container">
                <div v-if="references && references.length">
                    <FeatureCard
                        v-for="(reference, i) in references"
                        :key="reference.id"
                        :title="reference.title"
                        :content="reference.content"
                        :illustration="reference.image"
                        :reversed="i % 2 === 1"
                        :rounded-t-r="i !== references.length - 1 || references.length === 1"
                        :rounded-b-l="(i === references.length - 1 && i % 2 === 1) || i !== 0"
                        :rounded-b-r="i % 2 === 0 && references.length - 1 === i"
                    />
                </div>

                <div v-else>{{ $t('case_studies.no_results') }}</div>
            </div>
        </div>

        <div v-if="services && services.length" class="bg-white pt-16">
            <div class="rounded-tr-40 md:rounded-tr-100 shadow-xl--custom bg-gray-900 pt-14 pb-16">
                <SectionServices :services="services" />
            </div>
        </div>
    </div>
</template>

<script>
import Hero from '@/components/Heroes/Hero';
import FeatureCard from '@/components/Cards/FeatureCard/FeatureCard';
import SectionServices from '@/components/Sections/SectionServices/SectionServices';

export default {
    name: 'CaseStudies',
    components: {
        Hero,
        FeatureCard,
        SectionServices,
    },
    async asyncData({ $axios }) {
        let references = null;
        let services = null;

        try {
            await Promise.all([$axios.$get(`/reference`), $axios.$get('/service')])
                .then(([referencesRes, servicesRes]) => {
                    if (referencesRes.success === 1) {
                        references = referencesRes.data;
                    }

                    if (servicesRes.success === 1) {
                        services = servicesRes.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }

        return { references, services };
    },
    head() {
        return {
            title: this.$t('case_studies.title'),
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.$getOgTitle(this.$t('case_studies.title')),
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: this.$getOgTitle(this.$t('case_studies.title')),
                },
            ],
        };
    },
};
</script>

<style>
.case-studies-wrapper {
    li {
        padding-left: 1.5rem;
        list-style-type: none;
        &::before {
            content: '\e909' !important;
            font-family: 'primeicons', sans-serif;
            font-weight: bold;
            font-size: 14px;
            color: black;
        }
    }
}
</style>
